import { render, staticRenderFns } from "./LicitacoesComunicacoes.vue?vue&type=template&id=4624bc81&scoped=true&"
import script from "./LicitacoesComunicacoes.vue?vue&type=script&lang=js&"
export * from "./LicitacoesComunicacoes.vue?vue&type=script&lang=js&"
import style0 from "./LicitacoesComunicacoes.vue?vue&type=style&index=0&id=4624bc81&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4624bc81",
  null
  
)

export default component.exports